module.exports = __webpack_public_path__ + "top_100_sports.png";